import { render, staticRenderFns } from "./MobileHomeSkills.vue?vue&type=template&id=d904c212&lang=pug&"
import script from "./MobileHomeSkills.vue?vue&type=script&lang=js&"
export * from "./MobileHomeSkills.vue?vue&type=script&lang=js&"
import style0 from "./MobileHomeSkills.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports